import React from 'react';
import { useNavigate } from 'react-router-dom';

export const HomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url(/background1.jpeg)' }}
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-between py-16 px-6">
        {/* Top spacer */}
        <div />

        {/* Center Content - Logo & Branding */}
        <div className="flex flex-col items-center text-center">
          {/* Logo Icon */}
          <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full border-4 border-white/30 flex items-center justify-center mb-6 backdrop-blur-sm bg-white/10">
            <img src="/icon.png" alt="GHAFES Logo" className="w-16 h-16 sm:w-20 sm:h-20 object-contain" />
          </div>

          {/* Brand Name */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-wider mb-4">
            GHAFES
          </h1>
          <h2 className="text-xl sm:text-2xl text-white/90 font-light tracking-widest mb-6">
            LIBRARY
          </h2>

          {/* Tagline */}
          <p className="text-white/80 text-sm sm:text-base italic max-w-xs">
            Your digital library, brought to you.
          </p>
        </div>

        {/* Bottom - CTA Buttons */}
        <div className="w-full max-w-sm space-y-4">
          <button
            onClick={() => navigate('/signup')}
            className="w-full py-4 px-8 bg-white/10 backdrop-blur-md border-2 border-white/40 text-white font-semibold tracking-wider rounded-full hover:bg-white/20 hover:border-white/60 transition-all duration-300 uppercase text-sm"
          >
            Create Account
          </button>

          <button
            onClick={() => navigate('/login')}
            className="w-full py-4 px-8 bg-primary-700 text-white font-semibold tracking-wider rounded-full hover:bg-primary-800 transition-all duration-300 uppercase text-sm shadow-lg shadow-primary-900/30"
          >
            Sign In
          </button>

          {/* Alternative link */}
          <p className="text-center text-white/60 text-sm mt-6">
            Already have an account?{' '}
            <button
              onClick={() => navigate('/login')}
              className="text-white underline underline-offset-2 hover:text-primary-200 transition-colors"
            >
              Log in
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};
